// Polyfill
// import 'babel-polyfill'
// import 'utility/polyfills/closest'

// Globals
// import { ShowMediaLabel } from 'helpers/Globals'

// Helpers
// import ClickOutside from 'helpers/ClickOutside'

// Components
import Loader from 'components/loader/Loader'
import MobileNav from 'components/mobileNav/MobileNav'

// last...
import 'focus-visible'
import Embed from 'components/embed/Embed'
import PriorityNav from 'components/priority-nav/PriorityNav'
import Header from 'components/header/Header'
import Forms from 'components/forms/Forms'
import TransferOrders from 'components/transfer-orders/TransferOrders'

const App = {
	init: () => {
		// Always first...
		Loader.init()

		// Components
		MobileNav.init()
		Embed.init()
		Header.init()
		PriorityNav.init()
		Forms.init()
    TransferOrders.init()
	}
}

document.addEventListener('DOMContentLoaded', () => App.init())
